import { Flex } from "@chakra-ui/react";
import { ReqlameAqui } from "components";
import { Trustpilot } from "modules/storyblok/adapters/Trustpilot";
import { TrustpilotExcellent } from "./Trustpilot";

export type TrustpilotExtendedProps = {
  trustpilotVariant: "option-1" | "option-2";
  showReqlameAqui?: boolean;
  reqlameAquiStatus?: string;
  reqlameAquiScore?: number;
  reqlameAquiPosition?: "left" | "top";
};

export const TrustpilotExtended = ({
  trustpilotVariant,
  showReqlameAqui,
  reqlameAquiStatus,
  reqlameAquiScore,
  reqlameAquiPosition = "top",
}: TrustpilotExtendedProps) => (
  <Flex
    direction={{ base: "column", md: reqlameAquiPosition === "top" ? "column" : "row-reverse" }}
    rowGap={{ base: 4, md: 2 }}
    columnGap={8}
  >
    {showReqlameAqui && <ReqlameAqui score={reqlameAquiScore} status={reqlameAquiStatus} />}
    {trustpilotVariant === "option-1" ? <Trustpilot /> : <TrustpilotExcellent />}
  </Flex>
);
